var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { resetPasswordApi } from "apis/eduidResetPassword";
import { ResponseCodeButtons } from "components/Common/ResponseCodeAbortButton";
import { ResponseCodeForm } from "components/Login/ResponseCodeForm";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { FormattedMessage } from "react-intl";
import { clearNotifications } from "slices/Notifications";
import resetPasswordSlice from "slices/ResetPassword";
import { ResetPasswordStepIndicator } from "./ResetPasswordStepIndicator";
export function EmailLinkSent() {
    const dispatch = useAppDispatch();
    const response = useAppSelector((state) => state.resetPassword.email_response);
    const dashboard_link = useAppSelector((state) => state.config.dashboard_link);
    const reset_pw_status = useAppSelector((state) => state.resetPassword.reset_pw_status);
    const [verifyEmailLink] = resetPasswordApi.useLazyVerifyEmailLinkQuery();
    function handleSubmitCode(values) {
        return __awaiter(this, void 0, void 0, function* () {
            const code = values.v.join("");
            if (/^\d{6}$/.test(code)) {
                const response = yield verifyEmailLink({ email_code: code });
                if (response.isSuccess) {
                    dispatch(clearNotifications());
                    if (Object.values(response.data.payload.extra_security).length > 0) {
                        dispatch(resetPasswordSlice.actions.setNextPage("HANDLE_EXTRA_SECURITIES"));
                    }
                    else {
                        dispatch(resetPasswordSlice.actions.setNextPage("SET_NEW_PASSWORD"));
                    }
                }
            }
        });
    }
    function handleAbortButtonOnClick(event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (dashboard_link) {
            globalThis.location.href = dashboard_link;
            dispatch(resetPasswordSlice.actions.resetEmailStatus());
        }
    }
    if (!response) {
        return null;
    }
    return (_jsxs("div", { className: "step-container", children: [_jsxs("section", { className: "intro", children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "emailLinkSent.heading", defaultMessage: "Reset Password: Verify email address", description: "Reset Password email link sent heading" }) }), _jsxs("div", { className: "lead", children: [_jsx("p", { children: _jsx(FormattedMessage, { id: "common.enterSixDigitCode", defaultMessage: "Enter the six digit code sent from no-reply@eduid.se to {email} to verify your email address.", description: "Reset Password email link sent", values: {
                                        email: (_jsx("span", { children: _jsx("output", { "data-testid": "email-address", children: _jsx("strong", { children: response === null || response === void 0 ? void 0 : response.email }) }) })),
                                    } }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "emailLinkSent.haven", defaultMessage: "If you haven't received it, cancel and restart the process.", description: "Reset Password email link sent" }) })] })] }), (reset_pw_status === null || reset_pw_status === void 0 ? void 0 : reset_pw_status.email.expires_time_left) !== undefined && (_jsxs("p", { children: [_jsx(FontAwesomeIcon, { icon: faClock }), _jsx(FormattedMessage, { id: "emailLinkSent.code", defaultMessage: "The code is valid for 2 hours.", description: "Reset Password code expiry" })] })), _jsx("div", { className: "enter-code", children: _jsx(ResponseCodeForm, { inputsDisabled: false, handleSubmitCode: handleSubmitCode, children: _jsx(ResponseCodeButtons, { handleAbortButtonOnClick: handleAbortButtonOnClick }) }) }), _jsx(ResetPasswordStepIndicator, { currentStep: 3 })] }));
}
